import DetailsSummary from './DetailsSummary'

export default DetailsSummary
